import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyokuziteateListGetReq,
  TSyokuziteateListGetRes,
  TSyokuziteateListPutReq,
} from "./TSyokuziteate"

/**
 * 食事手当に対するAPIリクエスト用サービス
 *
 * @export
 * @class TenkenService
 * @extends {ConnectApi}
 */
export default class TenkenService extends ConnectApi {
  /**
   * 食事手当 一覧取得
   *
   * @param {TSyokuziteateListGetReq} params
   * @param {(param: TApiResponse<TSyokuziteateListGetRes>) => any} resolve
   * @param {(param: TApiResponse<TSyokuziteateListGetRes>) => any} reject
   * @memberof TenkenService
   */
  getList = async (params: TSyokuziteateListGetReq) => {
    try {
      // const res: AxiosResponse<TApiResponse<TZyomuinListGetRes>> =
      // await this.getInner(`/master/hinmei`, params)
      //return res.data
      //   if (params.年月 === "2" && params.品コード === "1") {
      //     // eslint-disable-next-line no-throw-literal
      //     throw "ERROR"
      //   }

      return {
        data: 食事手当一覧dummyList,
      }

      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }

  /**
   * 食事手当 更新
   *
   * @param {TSyokuziteateListPutReq} data
   * @param {(param: TApiResponse<TSyokuziteateListGetRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TSyokuziteateListGetRes[]>>) => any} reject
   * @memberof TenkenService
   */
  put = async (data: TSyokuziteateListPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truck/tenkenseibi/list`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  //   /**
  //    * 単体取得
  //    *
  //    * @param {TMenuInfoGetReq} params
  //    * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
  //    * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
  //    * @memberof MenuService
  //    */
  //   get = async (id: string | number) => {
  //     try {
  //       // const res: AxiosResponse<TApiResponse<TSyukkinboInfoGetRes[]>> =
  //       // await this.getInner(`/master/hinmei`, params)
  //       //return res.data
  //       if (id === "3") {
  //         // eslint-disable-next-line no-throw-literal
  //         throw "ERROR"
  //       }

  //       return {
  //         data: dummyData[0],
  //       }
  //       //TODO: api実装必要
  //     } catch (err) {
  //       throw err
  //     }
  //   }

  //   /**
  //    * 単体登録
  //    *
  //    * @param {TKyotenPostReq} data
  //    * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
  //    * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
  //    * @memberof KyotenService
  //    */
  //   post = async (data: TSyukkinboRegisterPostReq) => {
  //     try {
  //       const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
  //         `master/hinmei/`,
  //         data
  //       )
  //       return res.data
  //     } catch (err) {
  //       throw err
  //     }
  //   }

  //   /**
  //    * 単体更新
  //    *
  //    * @param {TKyotenPostReq} data
  //    * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
  //    * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
  //    * @memberof KyotenService
  //    */
  //   put = async (id: string, data: TSyukkinboRegisterPostReq) => {
  //     try {
  //       const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
  //         `master/hinmei/${id}`,
  //         data
  //       )
  //       return res.data
  //     } catch (err) {
  //       throw err
  //     }
  //   }
}

//TODO:ダミーデータ
const 食事手当一覧dummyList: TSyokuziteateListGetRes[] = [
  {
    食事手当id: 1,
    積都道府県コード: "01",
    卸都道府県コード: "01",
    食事手当区分コード: "5",
    備考: "1",
    更新日時: "2022-01-01T00:00:00",
    modifyToken: "2022-01-01T00:00:00",
  },
  {
    食事手当id: 2,
    積都道府県コード: "02",
    卸都道府県コード: "02",
    食事手当区分コード: "4",
    備考: "",
    更新日時: "2022-01-01T00:00:00",
    modifyToken: "2022-01-01T00:00:00",
  },
  {
    食事手当id: 3,
    積都道府県コード: "03",
    卸都道府県コード: "03",
    食事手当区分コード: "1",
    備考: "3",
    更新日時: "2022-01-01T00:00:00",
    modifyToken: "2022-01-01T00:00:00",
  },
]
